module.exports = __webpack_public_path__ + "bz.svg?81f2d6419e0debccb76714ed466b0652";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/1x1/bz.svg
// module id = 1028
// module chunks = 0